module.exports = __webpack_public_path__ + "img/index-partners-banner-6.bf8e56ce.jpg";